<template>
    <ArnSchritt4Endkunde v-if="store.aok === 0"></ArnSchritt4Endkunde>
    <ArnSchritt4Aok v-if="store.aok > 0"></ArnSchritt4Aok>
  </template>
  
  <script setup>
  
  import { useRechnerStore } from '@/stores/rechner';
  import ArnSchritt4Endkunde from '@/components/arn/arn_schritt4_endkunde.vue';
  import ArnSchritt4Aok from '@/components/arn/arn_schritt4_aok.vue';
  const store = useRechnerStore();
  
  
  </script>